import { render, staticRenderFns } from "./SetupRulesPanel.vue?vue&type=template&id=06389b70&scoped=true"
import script from "./SetupRulesPanel.vue?vue&type=script&lang=js"
export * from "./SetupRulesPanel.vue?vue&type=script&lang=js"
import style0 from "./SetupRulesPanel.vue?vue&type=style&index=0&id=06389b70&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06389b70",
  null
  
)

export default component.exports